import React from 'react'
import {
    Box,
    Stack,
    Typography
} from '@mui/material'
import IconButton from '@mui/material/IconButton'
import FacebookIcon from '@mui/icons-material/Facebook'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import InstagramIcon from '@mui/icons-material/Instagram'

import data from '../../data/portfolio.json'

const Footer = () =>
    <Box padding="1% 5%">
        <Stack
            direction={{ xs: 'column', md: 'row' }}
            justifyContent="space-between"
            alignItems='center'
            pb={{ xs: 5 }}
            width={{ xs: '100%' }}>
            <Stack
                direction={{ xs: 'row' }}
                spacing={{ xs: 1 }}
                justifyContent="center"
                alignItems='center'
            >
                <IconButton
                    aria-label="Facebook"
                    href={data.facebook.url}
                    target='_blank'
                    sx={{
                        color: "#000000a1",
                        '&:hover': {
                            color: "#000000",
                        },
                    }}
                    title={data.facebook.title}
                >
                    <FacebookIcon fontSize='medium' />
                </IconButton>
                <IconButton
                    aria-label="Instagram"
                    href={data.instagram.url}
                    target='_blank'
                    sx={{
                        color: "#000000a1",
                        '&:hover': {
                            color: "#000000",
                        },
                    }}
                    title={data.instagram.title}
                >
                    <InstagramIcon fontSize='medium' />
                </IconButton>
                <IconButton
                    aria-label="WhatsApp"
                    href={data.whatsapp.url}
                    target='_blank'
                    sx={{
                        color: "#000000a1",
                        '&:hover': {
                            color: "#000000",
                        },
                    }}
                    title={data.whatsapp.title}
                >
                    <WhatsAppIcon fontSize='medium' />
                </IconButton>
                <Typography
                    variant="span"
                    gutterBottom
                    fontFamily={"Montserrat, sans-serif"}
                    sx={{
                        color: "#000000f1",
                        fontSize: { xs: 11 },
                    }}>
                    &copy; Mohammed Medhat El_Araby
                </Typography>
            </Stack>
            <Stack
                sx={{
                    justifyContent: "flex-end",
                    alignItems: "center",
                }}>
                <Typography
                    variant="p"
                    gutterBottom
                    fontFamily={"Montserrat, sans-serif"}
                    sx={{
                        color: "#000000f1",
                        fontSize: { xs: 11 },
                    }}>
                    Made by 💙
                    <Typography
                        variant="span"
                        gutterBottom
                        mx={0.5}
                        fontFamily={"Montserrat, sans-serif"}
                        onClick={() => window.open("https://mohammed-moataz.vercel.app", "_blank")}
                        sx={{
                            cursor: "pointer",
                            color: "#123456f1",
                            fontSize: { xs: 11 },
                            "&:hover": {
                                color: "#123456",
                                textDecoration: "underline",
                            }
                        }}>
                        Mohammed Moataz
                    </Typography>
                </Typography>
            </Stack>
        </Stack>
    </Box >

export default Footer